import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=7f09650b"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=7f09650b&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navigation: require('/vercel/path0/components/elements/Navigation.vue').default,Button: require('/vercel/path0/components/elements/Button.vue').default,MenuOverlay: require('/vercel/path0/components/elements/MenuOverlay.vue').default})
